import React from 'react';
import styles from '../category-row/list-components.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import classnames from 'classnames';

const STATUS = {
  NEW: {
    style: styles.new,
  },
  UPDATED: {
    style: styles.updated,
  },
};

export function RenderIndicationTag({ lastUpdate = 0, status = 'UPDATED' }) {
  const label = useSelector(getLang('ITEM_STATUS'))[status]?.toUpperCase();
  const style = status ? STATUS[status].style : STATUS.UPDATED.style;

  const previousLastUpdated =
    useSelector(({ knowledge }) => knowledge.previousLastUpdated) ?? Date.now();

  if (new Date(lastUpdate).getTime() - new Date(previousLastUpdated).getTime() < 0) return null;

  return (
    <div className={classnames([styles.indicationTag, style])}>
      <h5 className={styles.text}>{label}</h5>
    </div>
  );
}
